import { Component } from '@angular/core';
import {NavbarComponent} from "../../components/navbar/navbar.component";
import {AuthGuard} from "../../auth/auth,guard";
import {TopPayers} from "./top-payers/top-payers.component";
import {Money} from "./money/money.component";

@Component({
  selector: 'app-statistic',
  standalone: true,
  imports: [],
  template: ''
})
export class StatisticComponent {

}

export const STATISTIC_ROUTE = [
  {
    path: 'statistic',
    component: NavbarComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: StatisticComponent,
      },
      {
        path: 'top-payers',
        canActivate: [AuthGuard],
        component: TopPayers,
      },
      {
        path: 'money',
        canActivate: [AuthGuard],
        component: Money,
      },
      {
        path: '**',
        redirectTo: ''
      },
    ],
  }
]

